import { IS_SHOW_AI_USAGE, OPEN_DEPLOY, EXTERNAL_DEPLOY, HAS_ENTERPRISE_QUOTA, } from '@/config/constant';
import { isSuper, isEnterprise } from '@/utils/userInfo';
export const AI_USAGE_ROUTES = {
    personal: '/ai/personal',
    enterprise: '/ai/enterprise',
    deploy: '/ai/deploy',
};
export function canRegisterAiRoutes() {
    return IS_SHOW_AI_USAGE;
}
export function showQuotaTab() {
    return OPEN_DEPLOY || EXTERNAL_DEPLOY;
}
export function showPersonalAiUsage(pageMode = 'editor') {
    if (pageMode === 'runtime')
        return false;
    return IS_SHOW_AI_USAGE;
}
export function showEnterpriseAiUsage(pageMode = 'editor') {
    if (pageMode === 'runtime')
        return false;
    return IS_SHOW_AI_USAGE && HAS_ENTERPRISE_QUOTA && isEnterprise();
}
export function showDeployAiUsage(pageMode = 'editor') {
    if (pageMode === 'runtime')
        return false;
    return IS_SHOW_AI_USAGE && isSuper();
}
export function canAccessEnterpriseAiUsage() {
    return showEnterpriseAiUsage();
}
export function canAccessDeployAiUsage() {
    return showDeployAiUsage();
}
